import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignCenterSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 17v2h10v-2H7zm-4-2h18v-2H3v2zm4-6v2h10V9H7zM3 5v2h18V5H3z" />
  </svg>
);
export default IconAlignCenterSizeM;
